'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var tslib_es6 = require('../../tslib.es6-130a177d.js');
var React = require('react');
var Theme_index = require('../../Theme/index.js');
require('styled-components');
require('../../index-b5b06755.js');
require('../../index-33f41a46.js');
require('../../Theme/common/index.js');
require('../../Theme/inputs/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var ErrorIcon = function (props) { return (React__default['default'].createElement("svg", tslib_es6.__assign({ width: "28", height: "28", viewBox: "0 0 28 28", fill: "currentColor" }, props),
    React__default['default'].createElement("path", { d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z", fill: Theme_index.theme.colors.iconCritical }),
    React__default['default'].createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.3311 17.9186L17.9186 18.331L14 14.4125L10.0815 18.331L9.669 17.9186L13.5875 14L9.669 10.0815L10.0815 9.66898L14 13.5875L17.9186 9.66898L18.3302 10.0823L14.4125 14L18.3311 17.9186Z", fill: Theme_index.theme.colors.white }))); };

exports.default = ErrorIcon;
//# sourceMappingURL=index.js.map
